module.exports = __webpack_public_path__ + "img/OIGA.c2996969.jpg";